export default __webpack_public_path__ + "static/media/fei.3618cb81.svg";